// import React, { useState, useEffect } from "react";
// import css from "./card.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/xCardIcon.svg";
// import ProdInCard from "./prodInCard";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../../firebase";
// import { useNavigate } from "react-router-dom";
// const isTrueish = (value) =>
//   value === true || value === "true" || value === 1 || value === "1";

// const toNumber = (value) => {
//   const n = Number(value);
//   return Number.isFinite(n) ? n : 0;
// };

// const round = (value) => Math.round(toNumber(value));

// const isPreorderProduct = (p) =>
//   Boolean(
//     isTrueish(p?.predprodag) ||
//     isTrueish(p?.predprodazh) ||
//     isTrueish(p?.isPreorder) ||
//     isTrueish(p?.preorder) ||
//     p?.categorySlug === "predprodazh" ||
//     p?.section === "predprodazh" ||
//     p?.group === "predprodazh",
//   );

// const getPreorderCartPrices = (p) => {
//   const price = round(p?.price);
//   const priceSale = round(p?.priceSale);
//   const preorderPrice = round(p?.preorderPrice);

//   const allCandidates = [
//     price,
//     priceSale,
//     preorderPrice,
//     round(p?.oldPrice),
//     round(p?.oldprice),
//     round(p?.old_price),
//     round(p?.regularPrice),
//     round(p?.basePrice),
//     round(p?.fullPrice),
//     round(p?.retailPrice),
//     round(p?.originalPrice),
//     round(p?.priceBeforeDiscount),
//     round(p?.priceWithoutDiscount),
//     round(p?.preorderOldPrice),
//     round(p?.preorderBasePrice),
//   ].filter((value) => value > 0);

//   if (!allCandidates.length) {
//     return {
//       finalPrice: 0,
//       originalPrice: 0,
//       hasPreorderSale: false,
//     };
//   }

//   // Для передпродажу беремо меншу ціну як акційну.
//   // Наприклад: 230 і 184 => finalPrice = 184, originalPrice = 230.
//   const finalPrice = Math.min(...allCandidates);
//   const originalPrice = Math.max(...allCandidates);

//   return {
//     finalPrice,
//     originalPrice,
//     hasPreorderSale: originalPrice > finalPrice,
//   };
// };
// export default function CartPage({ setCartCounterC, setCountProductForCart }) {
//   const [cartProducts, setCartProducts] = useState([]);
//   const [finishPrice, setFinishPrice] = useState(0);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchProducts = async () => {
//       const productsSnapshot = await getDocs(collection(db, "product"));
//       const allProducts = productsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const bundlesSnapshot = await getDocs(collection(db, "bundles"));
//       const bundles = bundlesSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const actionsSnapshot = await getDocs(collection(db, "actions"));
//       const actions = actionsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const salesSnapshot = await getDocs(collection(db, "sales"));
//       const sales = salesSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
//       const now = new Date();

//       let productsInCart = cartItems
//         .map((item) => {
//           const found = allProducts.find((p) => p.id === item.uid);
//           if (!found) return null;
//           return { ...found, quantity: item.quantity, uid: found.id };
//         })
//         .filter(Boolean);

//       // bundle discounts
//       bundles.forEach((bundle) => {
//         const bundleProductIds = (bundle.products || []).map(
//           (p) => p.productId,
//         );

//         const inCartAllBundle =
//           bundleProductIds.length > 0 &&
//           bundleProductIds.every((pid) =>
//             productsInCart.some((p) => p.id === pid),
//           );

//         if (inCartAllBundle) {
//           productsInCart = productsInCart.map((product) => {
//             const bundleProduct = (bundle.products || []).find(
//               (p) => p.productId === product.id,
//             );
//             return bundleProduct
//               ? { ...product, bundleDiscount: bundleProduct.discount }
//               : product;
//           });
//         }
//       });

//       const getSeries = (p) => {
//         if (Array.isArray(p.seria)) return p.seria;
//         if (typeof p.seria === "string" && p.seria) return [p.seria];
//         if (Array.isArray(p.series)) return p.series;
//         if (typeof p.series === "string" && p.series) return [p.series];
//         return [];
//       };

//       const getAuthors = (p) => {
//         if (Array.isArray(p.textAutor))
//           return p.textAutor.map((a) => a.split(" ")[0].trim());
//         if (typeof p.textAutor === "string" && p.textAutor)
//           return [p.textAutor.split(" ")[0].trim()];
//         return [];
//       };

//       const matchByRule = (rule, product) => {
//         const start = rule.startDate ? new Date(rule.startDate) : null;
//         const end = rule.endDate ? new Date(rule.endDate) : null;
//         if (end && now > end) return false;
//         if (start && now < start) return false;

//         const applies = rule.appliesTo || {};

//         const matchProduct =
//           Array.isArray(applies.products) &&
//           applies.products.includes(product.id);

//         const productSeries = getSeries(product);
//         const matchSeries =
//           Array.isArray(applies.series) &&
//           productSeries.some((ser) => applies.series.includes(ser));

//         const productAuthors = getAuthors(product);
//         const ruleAuthors = Array.isArray(applies.authors)
//           ? applies.authors.map((a) => a.split(" ")[0].trim())
//           : [];
//         const matchAuthor = productAuthors.some((a) => ruleAuthors.includes(a));

//         return matchProduct || matchSeries || matchAuthor;
//       };

//       // finalPrice priority: priceSale > sales > actions, + bundle поверх
//       const updated = productsInCart.map((p) => {
//         const basePrice = Number(p.price);

//         const manualSale =
//           p.priceSale !== undefined &&
//           p.priceSale !== "" &&
//           p.priceSale !== null;

//         const matchedSale = sales.find((s) => matchByRule(s, p));
//         const matchedAction = actions.find((a) => matchByRule(a, p));

//         let finalPrice = basePrice;

//         if (manualSale) {
//           finalPrice = Math.round(Number(p.priceSale));
//         } else if (matchedSale?.discountPercent) {
//           const pct = Number(matchedSale.discountPercent) || 0;
//           finalPrice = Math.round(basePrice - (basePrice * pct) / 100);
//         } else if (matchedAction?.discountPercent) {
//           const pct = Number(matchedAction.discountPercent) || 0;
//           finalPrice = Math.round(basePrice - (basePrice * pct) / 100);
//         }

//         if (p.bundleDiscount) {
//           const bPct = Number(p.bundleDiscount) || 0;
//           finalPrice = Math.round(finalPrice - (finalPrice * bPct) / 100);
//         }

//         return { ...p, finalPrice, originalPrice: basePrice };
//       });

//       setCartProducts(updated);
//     };

//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     const total = cartProducts.reduce(
//       (acc, p) => acc + p.finalPrice * p.quantity,
//       0,
//     );
//     const totalQty = cartProducts.reduce((acc, p) => acc + p.quantity, 0);

//     setFinishPrice(total);
//     if (setCountProductForCart) setCountProductForCart(totalQty);
//   }, [cartProducts, setCountProductForCart]);

//   const handleQuantityChange = (uid, qty) => {
//     const updated = cartProducts.map((p) =>
//       p.uid === uid ? { ...p, quantity: qty } : p,
//     );

//     const cartLS = (JSON.parse(localStorage.getItem("cart")) || []).map((p) =>
//       p.uid === uid ? { ...p, quantity: qty } : p,
//     );

//     localStorage.setItem("cart", JSON.stringify(cartLS));
//     setCartProducts(updated);
//     if (setCartCounterC) setCartCounterC((prev) => prev + 1);
//   };

//   const removeProduct = (uid) => {
//     const updated = cartProducts.filter((p) => p.uid !== uid);

//     const cartLS = (JSON.parse(localStorage.getItem("cart")) || []).filter(
//       (p) => p.uid !== uid,
//     );

//     localStorage.setItem("cart", JSON.stringify(cartLS));
//     setCartProducts(updated);
//     if (setCartCounterC) setCartCounterC((prev) => prev + 1);
//   };

//   const goToOrder = () => {
//     if (cartProducts.length > 0) navigate("/order");
//   };

//   // ❗️Замість cartClose — просто “назад” або в каталог
//   const goBack = () => navigate(-1);

//   return (
//     <div className={`${css.cardWrap} ${css.cardWrapPage}`}>
//       <div className={css.popUpWrap}>
//         <div className={css.nameCountWrap}>
//           <h2 className={css.countH2}>Ваш кошик ({cartProducts.length})</h2>

//           {/* ✅ залишаємо ту саму кнопку “X” (вигляд 1-в-1), але робимо “Назад” */}
//           <HandySvg
//             onClick={goBack}
//             src={iconSrc}
//             width="28"
//             height="28"
//             className={css.countSvg}
//           />
//         </div>

//         <div className={css.productInCardWrap}>
//           {cartProducts.map((el, index) => (
//             <ProdInCard
//               key={index}
//               el={el}
//               handleQuantityChange={handleQuantityChange}
//               removeProduct={removeProduct}
//             />
//           ))}
//         </div>

//         <div className={css.fullPriceBlockWrap}>
//           <h3 className={css.finalPrice}>Всього: {finishPrice} грн</h3>
//           <div className={css.buttonPriceWrap}>
//             <div className={css.nextJoin} onClick={goBack}>
//               Продовжити вибір
//             </div>
//             <div className={css.finalOrder} onClick={goToOrder}>
//               Оформити замовлення
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import css from "./card.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/xCardIcon.svg";
import ProdInCard from "./prodInCard";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import { useNavigate } from "react-router-dom";
const isTrueish = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const round = (value) => Math.round(toNumber(value));

const isPreorderProduct = (p) =>
  Boolean(
    isTrueish(p?.predprodag) ||
    isTrueish(p?.predprodazh) ||
    isTrueish(p?.isPreorder) ||
    isTrueish(p?.preorder) ||
    p?.categorySlug === "predprodazh" ||
    p?.section === "predprodazh" ||
    p?.group === "predprodazh",
  );

const getPreorderCartPrices = (p) => {
  const price = round(p?.price);
  const priceSale = round(p?.priceSale);
  const preorderPrice = round(p?.preorderPrice);

  const allCandidates = [
    price,
    priceSale,
    preorderPrice,
    round(p?.oldPrice),
    round(p?.oldprice),
    round(p?.old_price),
    round(p?.regularPrice),
    round(p?.basePrice),
    round(p?.fullPrice),
    round(p?.retailPrice),
    round(p?.originalPrice),
    round(p?.priceBeforeDiscount),
    round(p?.priceWithoutDiscount),
    round(p?.preorderOldPrice),
    round(p?.preorderBasePrice),
  ].filter((value) => value > 0);

  if (!allCandidates.length) {
    return {
      finalPrice: 0,
      originalPrice: 0,
      hasPreorderSale: false,
    };
  }

  // Для передпродажу беремо меншу ціну як акційну.
  // Наприклад: 230 і 184 => finalPrice = 184, originalPrice = 230.
  const finalPrice = Math.min(...allCandidates);
  const originalPrice = Math.max(...allCandidates);

  return {
    finalPrice,
    originalPrice,
    hasPreorderSale: originalPrice > finalPrice,
  };
};
export default function CartPage({ setCartCounterC, setCountProductForCart }) {
  const [cartProducts, setCartProducts] = useState([]);
  const [finishPrice, setFinishPrice] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      const productsSnapshot = await getDocs(collection(db, "product"));
      const allProducts = productsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const bundlesSnapshot = await getDocs(collection(db, "bundles"));
      const bundles = bundlesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const actionsSnapshot = await getDocs(collection(db, "actions"));
      const actions = actionsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const salesSnapshot = await getDocs(collection(db, "sales"));
      const sales = salesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
      const now = new Date();

      let productsInCart = cartItems
        .map((item) => {
          const found = allProducts.find((p) => p.id === item.uid);
          if (!found) return null;
          return { ...found, quantity: item.quantity, uid: found.id };
        })
        .filter(Boolean);

      // bundle discounts
      bundles.forEach((bundle) => {
        const bundleProductIds = (bundle.products || []).map(
          (p) => p.productId,
        );

        const inCartAllBundle =
          bundleProductIds.length > 0 &&
          bundleProductIds.every((pid) =>
            productsInCart.some((p) => p.id === pid),
          );

        if (inCartAllBundle) {
          productsInCart = productsInCart.map((product) => {
            const bundleProduct = (bundle.products || []).find(
              (p) => p.productId === product.id,
            );
            return bundleProduct
              ? { ...product, bundleDiscount: bundleProduct.discount }
              : product;
          });
        }
      });

      const getSeries = (p) => {
        if (Array.isArray(p.seria)) return p.seria;
        if (typeof p.seria === "string" && p.seria) return [p.seria];
        if (Array.isArray(p.series)) return p.series;
        if (typeof p.series === "string" && p.series) return [p.series];
        return [];
      };

      const getAuthors = (p) => {
        if (Array.isArray(p.textAutor))
          return p.textAutor.map((a) => a.split(" ")[0].trim());
        if (typeof p.textAutor === "string" && p.textAutor)
          return [p.textAutor.split(" ")[0].trim()];
        return [];
      };

      const matchByRule = (rule, product) => {
        const start = rule.startDate ? new Date(rule.startDate) : null;
        const end = rule.endDate ? new Date(rule.endDate) : null;
        if (end && now > end) return false;
        if (start && now < start) return false;

        const applies = rule.appliesTo || {};

        const matchProduct =
          Array.isArray(applies.products) &&
          applies.products.includes(product.id);

        const productSeries = getSeries(product);
        const matchSeries =
          Array.isArray(applies.series) &&
          productSeries.some((ser) => applies.series.includes(ser));

        const productAuthors = getAuthors(product);
        const ruleAuthors = Array.isArray(applies.authors)
          ? applies.authors.map((a) => a.split(" ")[0].trim())
          : [];
        const matchAuthor = productAuthors.some((a) => ruleAuthors.includes(a));

        return matchProduct || matchSeries || matchAuthor;
      };

      // finalPrice priority: priceSale > sales > actions, + bundle поверх
      const updated = productsInCart.map((p) => {
        const basePrice = Number(p.price) || 0;
        const isPreorder = isPreorderProduct(p);

        // ОКРЕМА ЛОГІКА ТІЛЬКИ ДЛЯ ПЕРЕДПРОДАЖУ В КОРЗИНІ
        if (isPreorder) {
          const preorderPrices = getPreorderCartPrices(p);

          return {
            ...p,
            finalPrice: preorderPrices.finalPrice,
            originalPrice: preorderPrices.originalPrice,

            isPreorderPrice: preorderPrices.hasPreorderSale,
            isPriceSale: preorderPrices.hasPreorderSale,
            isSalePrice: preorderPrices.hasPreorderSale,
            isActionPrice: false,
            isBundlePrice: false,
          };
        }

        // СТАРА ЛОГІКА ДЛЯ ВСІХ ІНШИХ ТОВАРІВ
        const manualSale =
          p.priceSale !== undefined &&
          p.priceSale !== "" &&
          p.priceSale !== null;

        const matchedSale = sales.find((s) => matchByRule(s, p));
        const matchedAction = actions.find((a) => matchByRule(a, p));

        let finalPrice = basePrice;
        let isPriceSale = false;
        let isSalePrice = false;
        let isActionPrice = false;
        let isBundlePrice = false;

        if (manualSale) {
          finalPrice = Math.round(Number(p.priceSale));
          isPriceSale = true;
        } else if (matchedSale?.discountPercent) {
          const pct = Number(matchedSale.discountPercent) || 0;
          finalPrice = Math.round(basePrice - (basePrice * pct) / 100);
          isSalePrice = true;
        } else if (matchedAction?.discountPercent) {
          const pct = Number(matchedAction.discountPercent) || 0;
          finalPrice = Math.round(basePrice - (basePrice * pct) / 100);
          isActionPrice = true;
        }

        if (p.bundleDiscount) {
          const bPct = Number(p.bundleDiscount) || 0;
          finalPrice = Math.round(finalPrice - (finalPrice * bPct) / 100);
          isBundlePrice = true;
        }

        return {
          ...p,
          finalPrice,
          originalPrice: basePrice,
          isPriceSale,
          isSalePrice,
          isActionPrice,
          isBundlePrice,
        };
      });

      setCartProducts(updated);
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const total = cartProducts.reduce(
      (acc, p) => acc + p.finalPrice * p.quantity,
      0,
    );
    const totalQty = cartProducts.reduce((acc, p) => acc + p.quantity, 0);

    setFinishPrice(total);
    if (setCountProductForCart) setCountProductForCart(totalQty);
  }, [cartProducts, setCountProductForCart]);

  const handleQuantityChange = (uid, qty) => {
    const updated = cartProducts.map((p) =>
      p.uid === uid ? { ...p, quantity: qty } : p,
    );

    const cartLS = (JSON.parse(localStorage.getItem("cart")) || []).map((p) =>
      p.uid === uid ? { ...p, quantity: qty } : p,
    );

    localStorage.setItem("cart", JSON.stringify(cartLS));
    setCartProducts(updated);
    if (setCartCounterC) setCartCounterC((prev) => prev + 1);
  };

  const removeProduct = (uid) => {
    const updated = cartProducts.filter((p) => p.uid !== uid);

    const cartLS = (JSON.parse(localStorage.getItem("cart")) || []).filter(
      (p) => p.uid !== uid,
    );

    localStorage.setItem("cart", JSON.stringify(cartLS));
    setCartProducts(updated);
    if (setCartCounterC) setCartCounterC((prev) => prev + 1);
  };

  const goToOrder = () => {
    if (cartProducts.length > 0) navigate("/order");
  };

  // ❗️Замість cartClose — просто “назад” або в каталог
  const goBack = () => navigate(-1);

  return (
    <div className={`${css.cardWrap} ${css.cardWrapPage}`}>
      <div className={css.popUpWrap}>
        <div className={css.nameCountWrap}>
          <h2 className={css.countH2}>Ваш кошик ({cartProducts.length})</h2>

          {/* ✅ залишаємо ту саму кнопку “X” (вигляд 1-в-1), але робимо “Назад” */}
          <HandySvg
            onClick={goBack}
            src={iconSrc}
            width="28"
            height="28"
            className={css.countSvg}
          />
        </div>

        <div className={css.productInCardWrap}>
          {cartProducts.map((el, index) => (
            <ProdInCard
              key={index}
              el={el}
              handleQuantityChange={handleQuantityChange}
              removeProduct={removeProduct}
            />
          ))}
        </div>

        <div className={css.fullPriceBlockWrap}>
          <h3 className={css.finalPrice}>Всього: {finishPrice} грн</h3>
          <div className={css.buttonPriceWrap}>
            <div className={css.nextJoin} onClick={goBack}>
              Продовжити вибір
            </div>
            <div className={css.finalOrder} onClick={goToOrder}>
              Оформити замовлення
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
